<script lang="ts">
  interface Props {
    html: any;
    override?: boolean;
    day: number;
    id?: string;
    disabled?: boolean;
    onUpdateValue?: (detail: { day: number; html: any; id?: string }) => void;
  }

  let {
    html = $bindable(),
    override = false,
    day,
    id,
    disabled = false,
    onUpdateValue = () => {},
  }: Props = $props();

  function setUpdatedValue() {
    if (disabled) return;
    if (html === '' || html === undefined) return;
    if (id) {
      onUpdateValue({
        day,
        html,
        id,
      });
      return;
    }
    onUpdateValue({
      day,
      html,
    });
  }
</script>

<textarea
  class:override
  class="textarea"
  bind:value={html}
  onblur={setUpdatedValue}
  {disabled}
  {id}
></textarea>
{#if html}
  <div class="print-view" aria-hidden="true">
    {@html html.replace(/(\r\n|\r|\n)/g, '<br/>')}
  </div>
{/if}

<style>
  .print-view {
    display: none;
  }

  @media print {
    .print-view {
      display: block;
      font-size: x-small;
      line-height: 1;
      color: black;
    }
  }

  .textarea {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans,
      Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
    border: none;
    width: 100%;
    height: auto;
    margin: 0;
    resize: none;
    font-size: 1rem;
    line-height: 22px;
    align-items: center;
    padding-inline: 5px;
    color: black;
    background-color: transparent;
    background-image: linear-gradient(
      0deg,
      #e0e0e0 2.27%,
      transparent 2.27%,
      transparent 50%,
      #e0e0e0 50%,
      #e0e0e0 52.27%,
      transparent 52.27%,
      transparent 100%
    );
    background-size: 44px 44px;
    word-break: break-all;
    outline: none;
  }

  @media screen and (max-width: 768px) {
    .textarea:not(.override) {
      display: none;
    }
  }

  @media print {
    .textarea {
      display: none;
    }
  }
</style>
